import {css} from 'styled-components'

const topAndBottomImageCardStyles = css`
img.small { max-width: 50%; }
img.medium { max-width: 75%; }
img.large { max-width: 100%; }
img.huge { width: 100%; }
img.original { max-width: 100%; }

img {
  height: auto;
}

.textSection {
  max-width: 60rem;
  margin-top: 1rem;
}

.imageSection,
.textSection {
  align-self: center;
}

h2,
h3 {
  text-align: center;
}
`

export default css`
display: flex;
flex-direction: column;
margin-bottom: 1rem;

.paragraph {
  margin: 1rem 0;
  line-height: 1.8rem;
}

.textSection {
  width: 100%;
  display: flex;
  flex-direction: column;

  > a,
  > button {
    align-self: stretch;
    @media (min-width: 960px) {
      align-self: center;
    }
  }
}

h2 { margin-bottom: 0.5rem; }

// old uic class
.h2 {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 2.25rem;
  line-height: 2.25rem;
}

.section-body {
  display: flex;
}

> .topCenter {
  > h2.h2,
  > .subTitle {
    text-align: center;
  }
}

> .topLeft {
  > h2.h2,
  > .subTitle {
    text-align: left;
    margin-left: 0;
  }
}

.leftImageCard,
.rightImageCard {
  flex-direction: column;
  ${topAndBottomImageCardStyles}
  img { margin: 0; }
}

&.leftImageCard,
&.rightImageCard {
  svg {
    margin: 2rem;
  }

  img {
    align-self: center;
  }
}

.topImageCard {
  flex-direction: column;
}

.bottomImageCard {
  flex-direction: column-reverse;
}

&.topImageCard,
&.bottomImageCard {
  ${topAndBottomImageCardStyles}
}

@media (min-width: 770px) {
  .leftImageCard {
    flex-direction: row;
    padding-bottom: 0;
    img { margin-right: 5rem; }
  }

  .rightImageCard {
    flex-direction: row-reverse;
    padding-bottom: 0;
    img { margin-left: 5rem; };
  }

  &.leftImageCard,
  &.rightImageCard {

    img.small    { max-width: 25%; }
    img.medium   { max-width: 33%; }
    img.large    { max-width: 50%; }
    img.original { max-width: 50%; }
    img.huge     { max-width: 75%; }

    img {
      height: auto;
      align-self: center;
    }

    h2,
    h3 {
      text-align: left;
    }
  }
}

&.slide {
  .section-body {
    height: 35vw;
  }

  .textSection {
    background-image: url('../../images/corner-logo-light.svg');
    background-color: #009fb0;
    color: white;
    border: 1px solid #334b4f;
    align-self: stretch;
    margin: 0;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;

    h2 {
      text-align: center;
    }

    h3 {
      padding: 0 1rem;
      font-weight: 300;
      text-align: center;
    }
  }

  img {
    height: 100%;
    width: 50%;
    object-fit: cover;
    margin: 0;
  }

  @media (max-width: 960px) and (min-width: 770px) {
    .section-body {
      .textSection {
        padding: 0.5rem;

        h2 {
          font-size: 1.5rem;
        }

        .subTitle {
          font-size: 1.125rem;
          text-align: center;
          margin-bottom: 0.25rem;
        }

        .paragraph h3 {
          font-size: 0.87rem;
          margin: 0.5rem 0;
        }
      }
    }
  }

  @media (max-width: 450px) {
    .section-body {
      height: initial;
    }

    .textSection {
      background-size: 30%;
      width: 100%;
    }

    img {
      width: 100%;
      height: inherit;
    }

    h2 { font-size: 1.5rem; }

    .subTitle {
      padding: 0 2rem;
      font-size: 1.125rem;
    }

    .paragraph h3 { font-size: 0.87rem; }
  }
}

&.contained,
&.containedBrand {
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 3px 24px -4px rgba(102, 102, 102, 0.3);
  overflow: hidden;

  .topImageCard,
  .bottomImageCard {
    .textSection {
      padding: 0 1.5rem;
    }
  }

  @media (min-width: 770px) {
    .leftImageCard {
      padding-right: 1.5rem;
    }
    .rightImageCard {
      padding-left: 1.5rem;
    }
  }
}

&.containedBrand {
  background-image: url('../../images/card-branded-bg.svg');
}

&.containedBrand,
&.slide .textSection {
  background-repeat: no-repeat;
  background-position: right bottom;
}
`